<template>
  <div class="relative">
    <img :src="imageSrc" class="w-[100%] min-h-[400px] object-cover" />
    <div class="absolute bg-white opacity-90 lg:mx-0 mx-auto left-0 right-0 top-[10%] lg:right-[-50%] md:w-[400px] w-[80%] container py-8">
      <h2 variant="h2" class="mb-2 font-bold  md:text-2xl text-lg" v-html="headingText"></h2>
      <p >{{ paragraphText }}</p>
      <!-- <Button
        tag="a"
        :href="buttonLink"
        target="_blank"
        :variant="buttonVariant"
        class="w-[100%] mt-4"
      >
        {{ buttonText }}
      </Button> -->
    </div>
  </div>
</template>

<script>

export default {
  name: "Hero",
  props: {
    imageSrc: String,
    headingText: String,
    paragraphText: String,
    buttonLink: String,
    buttonVariant: String,
    buttonText: String,
  },
};
</script>